import { InfoWindow, Marker } from '@react-google-maps/api';
import { useRouter } from 'next/navigation';
import MarkerIcon from '@/../public/icons/markerResize.png';
import SelectedIcon from '@/../public/icons/selectedMarker.png';
import { useEffect, useState } from 'react';
import { useSelectedMarker } from '../hooks/use-selected-marker';
import MarkerCard from './marker-card';

const ExploreMapMarker = ({ experience }: any) => {
  const router = useRouter();
  const center = new google.maps.LatLng(
    experience?.node?.approximateLocation?.coordinates[1],
    experience?.node?.approximateLocation?.coordinates[0],
  );
  const [selectedCenter, setSelectedCenter] = useState<google.maps.LatLng | null>(null);
  const { selectedMarker, setSelectedMarker } = useSelectedMarker();
  const [selected, setSelected] = useState(false);
  useEffect(() => {
    if (selectedMarker !== experience?.node?.id) {
      setSelected(false);
    }
  }, [experience?.node?.id, selectedMarker]);
  const isOpen = selectedCenter && selectedMarker === experience?.node?.id;

  const vancouver = new google.maps.LatLng(49.2827, 123.1207);
  return (
    <Marker
      key={experience?.node?.id}
      position={{
        lat: experience?.node?.approximateLocation?.coordinates[1],
        lng: experience?.node?.approximateLocation?.coordinates[0],
      }}
      icon={selected ? SelectedIcon.src : MarkerIcon.src}
      onClick={() => {
        setSelectedMarker(experience?.node?.id);
        setSelectedCenter(center);
        router.push(`#${experience?.node?.id}`);
        setSelected(true);
      }}
    >
      {isOpen && (
        <InfoWindow
          position={selectedCenter}
          onCloseClick={() => {
            setSelectedCenter(vancouver);
            setSelectedMarker('');
            setSelected(false);
            router.push(`#`);
          }}
        >
          <MarkerCard
            title={experience?.node?.title}
            imgSrc={experience?.node?.images?.edges[0]?.node?.file?.url}
            experienceId={experience?.node?.id}
          />
        </InfoWindow>
      )}
    </Marker>
  );
};
export default ExploreMapMarker;
